<template>
  <div class="layout2" style="background: #f2f5f7">
    <div class="mycc" style="background: #fff">
      <div class="sysHead">
        <div class="sysHead-l">
          <img :src="require(`@/assets/image/anxin/${row.name}.png`)" />
          <div>
            <h3>{{ row.name }}</h3>
            <h2>{{ row.value }}分</h2>
          </div>
        </div>
        <div class="sysHead-r">
          <img
            :src="require(`@/assets/image/anxin/iconChaNew.png`)"
            v-if="row.level == 1"
          />
          <img
            :src="require(`@/assets/image/anxin/iconZhongNew.png`)"
            v-if="row.level == 2"
          />
          <img
            :src="require(`@/assets/image/anxin/iconLiangNew.png`)"
            v-if="row.level == 3"
          />
          <img
            :src="require(`@/assets/image/anxin/iconYouNew.png`)"
            v-if="row.level == 4"
          />
        </div>
      </div>
      <markbox :item="row" style="margin-top: 60px"></markbox>
    </div>
    <div class="peaceTab1" :class="listSta ? '' : 'mytabTT'" :stast="listSta">
      <div
        class="intes-bt-box"
        v-show="row.son.length !== 0"
        style="padding: 0 15px"
      >
        <nozklist :list="row.son" v-if="listSta"></nozklist>
        <zklist :list="row.son" :laiyuan="'offLink'" v-else></zklist>
      </div>

      <div v-show="row.son.length == 0" style="text-align: center">
        暂无数据
      </div>
    </div>
  </div>
</template>
<script>
import zklist from "../../PeaceMindH5/components/zklist.vue"
import nozklist from "../../PeaceMindH5/components/noZklist.vue"
import markbox from "../../PeaceMindH5/components/markBox.vue"
export default {
  props: ['xiaohxt'],
  components: {
    zklist, markbox, nozklist
  },
  data () {
    return {
      activeNames: [],
      row: {},
      listSta: false
    }
  },
  
  created () {
    this.row = this.xiaohxt
    console.log(this.row)
    document.title = this.row.name
    this.row.name == '重金属' || this.row.name == '维生素' || this.row.name == '辅酶' || this.row.name == '微量元素' || this.row.name == '氨基酸' || this.row.name == '人体毒素' ? this.listSta = true : this.listSta = false
    this.row.son.forEach((item) => {
      try {
        item.gs = item.risk.length
      } catch (error) {

      }

    })

  },
  methods: {
    handClickFs () {
      this.showSuccess = true
    },
  }
}
</script>
<style lang="scss" >
.mycc {
  padding: 0.16rem 0.21333rem;
  color: #969799;
  font-size: 0.18667rem;
  line-height: 1.5;
  background-color: #fff;
  margin-top: 72px !important;
  box-shadow: 0px 10px 29px 0px rgba(91, 145, 190, 0.1);
  border-radius: 10px;
  margin: 0 30px;
  .sysHead {
    width: 500px;
    padding: 25px 35px 10px 35px;
    background: #ffffff;
    box-shadow: 0px 10px 29px 0px rgba(91, 145, 190, 0.16);
    border-radius: 10px;
    display: flex;
    margin: -35px auto 30px auto;

    .sysHead-l {
      display: flex;
      width: 50%;
      img {
        width: 70px;
        height: 70px;
        vertical-align: middle;
        margin-right: 25px;
        margin-top: 15px;
      }
      h3 {
        margin: 0 0 0 0;
        font-size: 26px;
        color: #333;
      }
      h2 {
        margin: 0 0 0 0;
        font-size: 36px;
        color: #333;
      }
    }
    .sysHead-r {
      width: 50%;
      text-align: center;
      img {
        width: 107px;
        height: 98px;
      }
    }
  }
}
.peaceTab1 {
  padding-top: 30px;
  .van-cell {
    padding: 30px 20px !important;
    font-size: 30px !important;
  }
  .van-collapse-item--border::after {
    border-color: #e3e1e1;
  }
  .van-tabs__nav--card {
    height: 100px !important;
    .van-tab {
      width: 160px !important;
      height: 60px !important;
      background: #e1f1ff;
      box-shadow: 0px 10px 13px 0px rgba(47, 153, 231, 0.3);
      border-radius: 30px;
      margin-right: 20px;
      padding: 0 !important;

      flex: 0 0 24% !important;
    }
  }
  .van-cell__value {
    padding-top: 20px;
    font-size: 26px;
    flex: 0.5;
    padding-right: 20px;
    overflow:auto
  }
  .van-cell__right-icon {
    margin-top: 20px !important;
  }
  .van-tab__text {
    font-size: 28px;
  }
  .van-tab--active {
    width: 160px !important;
    height: 60px !important;
    background: #008def !important;

    box-shadow: 0px 10px 13px 0px rgba(47, 153, 231, 0.3) !important;
    border-radius: 30px !important;
  }
  .van-tabs__wrap {
    height: 100px !important;
  }
  .van-tabs__nav {
    background: none;
    border: none;
  }
  .van-tabs__content--animated {
    padding-top: 0;
  }
}
.mytabTT {
  .van-cell__right-icon {
    margin-top: 0px !important;
  }
  .van-cell__value {
    padding-top: 0px !important;
    overflow:visible !important;
  }
}
</style>